/**
 * Estate values read at RUNTIME, from `/config.js` (MB-SOLUM #2702a, R4).
 *
 * A built bundle carries no estate values: the container renders `/config.js` at
 * start (`dist/web-config.sh`) and the page loads it as a classic script BEFORE
 * the module entry, so `window.__SOLUM_CONFIG__` exists by the time any module
 * evaluates. One CI-built bundle can then serve any estate.
 *
 * What is here, and what deliberately is not:
 *   · `VITE_SUPABASE_ANON_KEY` — signed with the estate's own JWT_SECRET, so it
 *     can never be part of a generic build.
 *   · `VITE_SOLUM_PROFILE` — which estate this console serves.
 *   · NOT the Supabase URL: builds use '/' (same-origin), which is no estate value.
 *     The URL also decides live-vs-fixture at BUILD time (dead-code elimination of
 *     the fixture dataset), and the CSP `connect-src` is derived from it.
 *
 * Absent or empty config falls back to `import.meta.env`, which keeps `pnpm dev`
 * and the Playwright builds working. A bundle that was built WITH a key baked in
 * is refused by build-web.mjs, not by this file.
 */
type Cfg = Record<string, string | undefined>

export function runtimeConfig(): Cfg {
  const c = (globalThis as { __SOLUM_CONFIG__?: unknown }).__SOLUM_CONFIG__
  return c && typeof c === 'object' ? (c as Cfg) : {}
}

/** The runtime value of `key`, else the build-time `import.meta.env` value. */
export function runtimeEnv(key: string): string | undefined {
  const v = runtimeConfig()[key]
  if (typeof v === 'string' && v !== '') return v
  return (import.meta.env as Cfg)[key]
}
